import { render, staticRenderFns } from "./lock.vue?vue&type=template&id=4d8fdca3&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d8fdca3",
  null
  
)

export default component.exports